import React, { useCallback, useEffect } from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import SharedDndProvider from 'components/DragDropContext/SharedDndProvider';
import Modal from '@aha-app/react-bootstrap-modal';
import FieldPreview from './components/FieldPreview';
import DragCardFieldPreview from './components/DragCardFieldPreview';
import LayoutEditorContents from './components/LayoutEditorContents';
import CardDragRegistry from 'javascripts/dnd/components/CardDragRegistry';
import DraggableFieldPreview from './dnd/DraggableFieldPreview';
import DraggableCardField from './dnd/DraggableCardField';
import DraggableDividerRow from './dnd/DraggableDividerRow';
import CardUiItem from './components/CardUiItem';
import DraggableUiItem from './dnd/DraggableUiItem';
import CardPreviewRow from './components/CardPreviewRow';
import CardLayoutEditorController from './controllers/CardLayoutEditorController';

const CardLayoutEditor = () => {
  const controller = useController(CardLayoutEditorController);
  const { open } = controller.state;

  const onHide = useCallback(() => {
    controller.actionCloseModal();
  }, [controller]);
  useEffect(() => {
    document.addEventListener('aha-modal-header:close', onHide);

    return () => {
      document.removeEventListener('aha-modal-header:close', onHide);
    };
  }, [onHide]);

  return (
    <SharedDndProvider>
      <Modal
        id='card-layout-editor'
        className='modal-flex'
        show={open}
        onHide={onHide}
      >
        <LayoutEditorContents />
      </Modal>

      <CardDragRegistry
        DraggableItemClass={DraggableFieldPreview}
        CardComponent={FieldPreview}
      />
      <CardDragRegistry
        DraggableItemClass={DraggableDividerRow}
        CardComponent={CardPreviewRow}
      />
      <CardDragRegistry
        DraggableItemClass={DraggableUiItem}
        CardComponent={CardUiItem}
      />
      <CardDragRegistry
        DraggableItemClass={DraggableCardField}
        CardComponent={DragCardFieldPreview}
      />
    </SharedDndProvider>
  );
};

export default view(CardLayoutEditor);
